export const MOBILE_SCREEN_MEDIA_QUERY = '@media screen and (max-width: 650px)';
